const url = process.env.REACT_APP_API_URL;

export const urls = {
  apiBaseUrl: url,
  officialWebSite: "https://www.raychemrpg.com/",
};

export const scanUrl = url;

const url_length = process.env.REACT_APP_Url_Length;

export const UrlLength = url_length;

// export const UrlLength = 40 // dev code

// export const UrlLength = 39 // Cloud Code
